module.exports = __webpack_public_path__ + "img/overview.93641d45.svg";